export default __webpack_public_path__ + "static/media/Initiate's Armbands of the Eternal Eclipse.c94c2ea7.jpg";